import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface GlobalPopupState {
  isOpen: boolean;
  imageUrl: string | null;
  linkUrl: string | null;
}

const initialState: GlobalPopupState = {
  isOpen: false,
  imageUrl: null,
  linkUrl: null,
};

export const globalPopupSlice = createSlice({
  name: "globalPopup",
  initialState,
  reducers: {
    openGlobalPopup: (
      state,
      action: PayloadAction<{ imageUrl: string; linkUrl: string | null }>,
    ) => {
      state.imageUrl = action.payload.imageUrl;
      state.linkUrl = action.payload.linkUrl;
      state.isOpen = true;
    },
    closeGlobalPopup: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openGlobalPopup, closeGlobalPopup } = globalPopupSlice.actions;

export default globalPopupSlice.reducer;
